import React, { useState, useCallback, useEffect } from "react";
import { ChoiceList } from "@shopify/polaris";
export const ChannelsModal = (props) => {
  const [selected, setSelected] = useState(props.selectedChannels);
  const handleChange = (value) => {
    setSelected(value);
    props.handleSelectedChannels(value);
  };
  // useEffect(() => {
  //   // setSelected(
  //   //   props.channels.map((item, index) => {
  //   //     return item.id;
  //   //   })
  //   // );
  // }, [props]);

  return (
    <ChoiceList
      allowMultiple
      choices={props.channels}
      selected={selected}
      onChange={handleChange}
    />
  );
};
